import React from "react";

import SignUpForm from "../components/SignUpForm";
import AuthLayout from "../layouts/AuthLayout";
import useQueryParams from "../hooks/useQuery";
import { useTranslation } from "react-i18next";

function SignUp() {
  const { t } = useTranslation("common");
  const query = useQueryParams();

  return (
    <AuthLayout title={t("auth.signupTitle")}>
      <SignUpForm
        initialValues={{
          email: "",
          password: "",
          confirmPassword: "",
          givenName: "",
          familyName: "",
          couponCode: query.get("coupon") || "",
        }}
      />
    </AuthLayout>
  );
}

export default SignUp;
